import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import imgUser from 'assets/img/team/y4-avata.png';
import Avatar from 'components/common/Avatar';
import { useTranslation, Trans } from 'react-i18next';
import { getQuickLink } from 'y4/Falcon';
import { isAuthorized } from 'y4/Authentication';
import AppContext from 'context/Context';
import DataContext from 'y4/context/DataContext';
import y from 'y4/Utils';

const ProfileDropdown = () => {
  const {
    config: { corp }
  } = useContext(AppContext);

  const { globalData } = useContext(DataContext);
  const userHeadImage = y.gpv(globalData, 'authentication.userHeadImage');

  const { t } = useTranslation(['user', 'auth', 'setting']);
  const [menus, setMenus] = useState(null);
  const [show, setShow] = useState(false);
  const is_auth = isAuthorized(corp);
  useEffect(() => {
    getQuickLink('profile').then(links => {
      setMenus(links);
    });
  }, []);

  return (
    <Dropdown navbar={true} show={show} autoClose as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        onClick={e => {
          e.preventDefault();
          setShow(!show);
        }}
        className="pe-0 ps-2 nav-link"
      >
        <Avatar src={userHeadImage ? userHeadImage : imgUser} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          {menus && (
            <>
              {menus.map((menu, index) => {
                if (menu.hr) {
                  return <Dropdown.Divider key={index} />;
                } else if (menu.icon) {
                  return (
                    <Dropdown.Item
                      key={index}
                      className="fw-bold text-warning"
                      href={t(menu.url)}
                      onClick={() => {
                        setShow(!show);
                      }}
                    >
                      <FontAwesomeIcon icon={menu.icon} className="me-1" />
                      <span>{t(menu.title)}</span>
                    </Dropdown.Item>
                  );
                } else {
                  return (
                    <Dropdown.Item
                      key={index}
                      as={Link}
                      onClick={() => {
                        setShow(!show);
                      }}
                      to={t(menu.url)}
                    >
                      {t(menu.title)}
                    </Dropdown.Item>
                  );
                }
              })}
            </>
          )}
          {is_auth ? (
            <>
              <Dropdown.Item
                as={Link}
                onClick={() => {
                  setShow(!show);
                }}
                to={`${corp}/user/profile`}
              >
                <Trans ns="user">Profile &amp; account</Trans>
              </Dropdown.Item>
              <Dropdown.Item
                as={Link}
                to={`${corp}/authentication/card/reset-password`}
              >
                <Trans ns="user">Reset password</Trans>
              </Dropdown.Item>
              <Dropdown.Item
                as={Link}
                to={`${corp}/authentication/card/logout`}
              >
                <Trans ns="user">Logout</Trans>
              </Dropdown.Item>
            </>
          ) : (
            <Dropdown.Item
              as={Link}
              onClick={() => {
                setShow(!show);
              }}
              to={`/${corp}/authentication/card/login`}
            >
              <Trans ns="auth">Log in</Trans>
            </Dropdown.Item>
          )}
          <Dropdown.Divider />
          <Dropdown.Item
            as={Link}
            onClick={e => {
              e.preventDefault();
              y.clearBuffer();
              y.toastSuccess(t('Buffer emptied', { ns: 'setting' }));
              setShow(!show);
            }}
          >
            <Trans ns="setting">Buffer empty</Trans>
          </Dropdown.Item>
          <Dropdown.Item
            as={Link}
            onClick={() => {
              setShow(!show);
            }}
            to={`${corp}/toasts`}
          >
            <Trans ns="setting">Notification</Trans>
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
